(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["product-section-clientstories"] && !Shopify.designMode) return;
  try {
    

(function(){

  var sid = "{{ section.id }}";

  var wrap = document.getElementById("clientStory_"+sid);

  if (wrap && typeof jQuery !== 'undefined' && jQuery.fn && jQuery.fn.slick && !jQuery(wrap).hasClass('slick-initialized')) {

    jQuery(wrap).slick({

      dots:false, infinite:false, speed:300, slidesToShow:4, slidesToScroll:4,

      responsive:[

        { breakpoint:1200, settings:{ slidesToShow:3, slidesToScroll:3 } },

        { breakpoint:768,  settings:{ slidesToShow:2, slidesToScroll:2 } },

        { breakpoint:520,  settings:{ slidesToShow:1, slidesToScroll:1 } }

      ]

    });

  }

  var openBtns = document.querySelectorAll(".js-open-video-"+sid);

  var closeBtns = document.querySelectorAll(".js-close-video-"+sid);

  var modal = document.getElementById("rprrModal_"+sid);

  var player = document.getElementById("rprrPlayer_"+sid);

  function yt(url){var m=url.match(/(?:youtube\.com.*v=|youtu\.be\/)([^&?/]+)/);return m&&m[1]?"https://www.youtube.com/embed/"+m[1]+"?autoplay=1&rel=0&modestbranding=1":url;}

  function vi(url){var m=url.match(/vimeo\.com\/(\d+)/);return m&&m[1]?"https://player.vimeo.com/video/"+m[1]+"?autoplay=1":url;}

  function openV(url){

    if(!url) return;

    var html='';

    if(/\.mp4(\?|$)/i.test(url)){ html='<video src="'+url+'" autoplay controls playsinline></video>'; }

    else if(/youtu\.?be/.test(url)){ html='<iframe src="'+yt(url)+'" frameborder="0" allow="autoplay; encrypted-media" allowfullscreen></iframe>'; }

    else if(/vimeo\.com/.test(url)){ html='<iframe src="'+vi(url)+'" frameborder="0" allow="autoplay; encrypted-media" allowfullscreen></iframe>'; }

    else{ html='<iframe src="'+url+'" frameborder="0" allow="autoplay; encrypted-media" allowfullscreen></iframe>'; }

    player.innerHTML=html; modal.classList.add("is-open"); modal.setAttribute("aria-hidden","false");

  }

  function closeV(){ modal.classList.remove("is-open"); modal.setAttribute("aria-hidden","true"); player.innerHTML=""; }

  openBtns.forEach(function(b){ b.addEventListener("click", function(){ openV(b.getAttribute("data-video")); }); });

  closeBtns.forEach(function(b){ b.addEventListener("click", closeV); });

})();


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-section-faq"] && !Shopify.designMode) return;
  try {
    

(function(){

  document.querySelectorAll('.faqs_wrapper .acc_bt').forEach(function(bt){

    bt.addEventListener('click', function(){

      var cnt = bt.parentElement.querySelector('.acc_cnt');

      if(!cnt) return;

      cnt.style.display = (cnt.style.display === 'block') ? 'none' : 'block';

    });

  });

})();


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product_bundle_magnesium"] && !Shopify.designMode) return;
  try {
    
  /* Hook your slider logic to #prevBtn/#nextBtn and .thumb[data-index] if needed */

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product_bundle_one"] && !Shopify.designMode) return;
  try {
    
  /* Hook your slider logic to #prevBtn/#nextBtn and .thumb[data-index] if needed */

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product_multivitaminbundle_one"] && !Shopify.designMode) return;
  try {
    
  /* Hook your slider logic to #prevBtn/#nextBtn and .thumb[data-index] if needed */

  } catch(e) { console.error(e); }
})();
})();
